import styled from 'styled-components';

import { Count, Pill, tokens } from '@treams/treams-ui';

const Mark = styled.img`
	display: block;
	width: 18px;
	height: 18px;
	flex-shrink: 0;
	border-radius: ${tokens.radius.xs}px;
	object-fit: cover;
`;

const PillMark = styled(Mark)`
	width: 16px;
	height: 16px;
`;

export function GoodHabitzLogo(props: { alt?: string }) {
	return <Mark src="/images/marketplace/goodhabitz-mark.png" alt={props.alt ?? ''} />;
}

export function GoodHabitzMark(props: { alt?: string }) {
	return (
		<Pill>
			<PillMark src="/images/marketplace/goodhabitz-mark.png" alt={props.alt ?? ''} />
		</Pill>
	);
}

export function GoodHabitzPill(props: { count: number }) {
	return (
		<Pill>
			<PillMark src="/images/marketplace/goodhabitz-mark.png" alt="" />
			GoodHabitz
			<Count count={props.count} />
		</Pill>
	);
}
